import React, { useEffect, useContext } from "react";
import { StoreContext } from "../../Context/StoreContext";
import Carousel from "react-multi-carousel";
import Previous from "../../VibehutUI/Icons/Previous";
import Next from "../../VibehutUI/Icons/Next";
import LiveCallCard from "./LiveCallCard";
import { useState } from "react";

function LiveCalls({ sliderWidth }) {
  const { state } = useContext(StoreContext);
   const { auth, room:{activeCalls}} = state;
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 769 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 768, min: 641 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;
    return activeCalls?.length > 3 ? (
      <div className="absolute right-1 top-12">
        <span className="flex space-x-3">
          <span onClick={() => previous()} className="cursor-pointer">
            <Previous disabled={currentSlide === 0} />
          </span>

          <span onClick={() => next()} className="cursor-pointer">
            <Next />
          </span>
        </span>
      </div>
    ) : (
      <></>
    );
  };

  return (
    <>
      {activeCalls?.length > 0 && (
        <div className="relative" style={{ width: sliderWidth }}>
          <div className="pt-8">
            <div className="px-2">
              <p className="font-bold md:text-2xl text-xl text-darkNight dark:text-frescoWhite">
                Vibe on Video
              </p>
              <p className="text-lg text-darkGray">
                You can join these active calls
              </p>
            </div>

            <div className="pt-4">
              <div className="hidden md:block">
                <Carousel
                  responsive={responsive}
                  renderButtonGroupOutside={true}
                  itemClass="px-2.5"
                  arrows={false}
                  shouldResetAutoplay={false}
                  customButtonGroup={<ButtonGroup />}
                >
                  {activeCalls.map((item, index) => (
                    <>
                      {item.users.length > 0 && (
                        <div key={index + item.room._id}>
                          <LiveCallCard
                            call={item}
                            isAuth={auth?.user?.token}
                            isBoostedCall={item.isBoostedCall}
                            boostedCallDetails={item.boostedCallDetails}
                          />
                        </div>
                      )}
                    </>
                  ))}
                </Carousel>
              </div>
              <div className="md:hidden flex flex-col gap-4">
                {activeCalls?.length>0 && activeCalls.map((item, index) => (
                  <>
                    {item.users.length > 0 && (
                      <div key={index + item.room._id}>
                        <LiveCallCard
                          call={item}
                          isAuth={auth?.user?.token}
                          isBoostedCall={item.isBoostedCall}
                          boostedCallDetails={item.boostedCallDetails}
                        />
                      </div>
                    )}
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default LiveCalls;
